<template>
  <div class="module-header">
    <el-form ref="headerForm" :model="localForm" label-width="80px">
      <el-row :gutter="20">
        <el-col :span="10">
          <el-form-item label="截止日期" prop="deadlineTime">
            <el-date-picker
              style="width: 100%"
              type="date"
              format="yyyy年M月d日"
              value-format="yyyy-MM-dd"
              placeholder="请选择日期"
              clearable
              v-model="localForm.deadlineTime"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="负责人" prop="personId">
            <el-select v-model="localForm.personId" placeholder="请选择负责人" style="width: 100%" clearable>
              <el-option v-for="item in userList" :key="item.id" :label="item.userName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4" align="right">
          <el-button type="success" size="small" icon="el-icon-check" @click="saveFn">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'ModuleHeader',
  props: {
    // 部门 ID（由父页面传入，用于拉取负责人列表）
    deptId: {
      type: [String, Number],
      required: true
    },
    scheduleFlag: {
      type: String
    },
    // 赛季 id（默认取路由参数，父页面也可通过 prop 覆盖）
    seasonId: {
      type: [String, Number],
      default () {
        return (this.$route && this.$route.query && this.$route.query.id) || ''
      }
    },
    // 外部传入的初始数据（可选）
    value: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      userList: [],
      localForm: {
        deadlineTime: '',
        deptId: '',
        initiateRemark: '',
        personId: '',
        personName: '',
        scheduleFlag: '',
        seasonProductId: ''
      }
    }
  },
  watch: {
    // 部门 ID 变化：重新拉取负责人列表
    deptId: {
      handler (newVal) {
        this.localForm.deadlineTime = ''
        this.localForm.personId = ''
        this.localForm.personName = ''
        this.userList = []
        if (newVal) {
          this.getDeptUserList(newVal)
        }
      },
      immediate: true
    },
    // 外部传入值变化时同步
    value: {
      handler (val) {
        // 有有效数据（id / 截止日期 / 负责人 任一存在）才回填，否则清空选择器，避免显示上一赛段残留内容
        if (val && (val.id || val.deadlineTime || val.personId)) {
          this.localForm = { ...val }
        } else {
          this.resetForm()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 负责人下拉数据：GET seasonProduct/deptUserList，传 id（部门的 value）
    getDeptUserList (id) {
      this.$http.get('seasonProduct/deptUserList?id=' + id).then(res => {
        if (res.code === 200) {
          this.userList = res.data || []
        }
      }).catch(() => {
        this.userList = []
      })
    },
    // 供父组件主动获取当前模块数据
    getForm () {
      return { ...this.localForm }
    },
    // 供父组件主动重置
    resetForm () {
      this.localForm = {
        deadlineTime: '',
        deptId: '',
        initiateRemark: '',
        personId: '',
        personName: '',
        scheduleFlag: '',
        seasonProductId: ''
      }
    },
    // 保存接口
    saveFn () {
      if (!this.localForm.deadlineTime) return this.$message.warning('请选择截止日期')
      if (this.localForm.personId) {
        this.localForm.personName = this.userList.find(item => item.id === this.localForm.personId).userName
      }

      this.localForm.deptId = this.deptId
      this.localForm.scheduleFlag = this.scheduleFlag
      this.localForm.seasonProductId = this.seasonId
      this.$http.post('seasonProduct/updateDeadlineTimeSj', this.localForm).then(res => {
        if (res.code === 200) {
          this.$message.success('保存成功')
          this.$emit('submit')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.module-header {
  padding: 10px 0;
  border-bottom: 2px dashed #ECF5FF;
  margin-bottom: 20px;
}
</style>
